import { render, staticRenderFns } from "./AboutView.vue?vue&type=template&id=2d78e011&scoped=true"
import script from "./AboutView.vue?vue&type=script&lang=js"
export * from "./AboutView.vue?vue&type=script&lang=js"
import style0 from "./AboutView.vue?vue&type=style&index=0&id=2d78e011&prod&scoped=true&lang=less"
import style1 from "./AboutView.vue?vue&type=style&index=1&id=2d78e011&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d78e011",
  null
  
)

export default component.exports